import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from "react-toastify";
import AuthService from '../services/AuthService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [isInitialAuthCheck, setIsInitialAuthCheck] = useState(true);

    // Vérifier l'état d'authentification au chargement (y compris après fermeture du navigateur)
    useEffect(() => {
        const currentUser = AuthService.getCurrentUser(); // gère l'expiration en interne
        if (currentUser) {
            setIsAuthenticated(true);
            setUser(currentUser);
        }
        setIsInitialAuthCheck(false);
    }, []);

    const login = (userData) => {
        setIsAuthenticated(true);
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
        AuthService.recordActivity(); // démarre le compteur de session
        toast.success("Connexion réussie !");
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUser(null);
        AuthService.logout(); // retire aussi le timestamp
        toast.success("Déconnexion réussie !");
    };

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            user,
            login,
            logout,
            isInitialAuthCheck
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export const ShowWhenAuthenticated = ({ children, fallback = null }) => {
    const { isAuthenticated, isInitialAuthCheck } = useAuth();
    if (isInitialAuthCheck) return null;
    return isAuthenticated ? children : fallback;
};

export const HideWhenAuthenticated = ({ children, fallback = null }) => {
    const { isAuthenticated, isInitialAuthCheck } = useAuth();
    if (isInitialAuthCheck) return null;
    return !isAuthenticated ? children : fallback;
};